module.exports = __webpack_public_path__ + "img/leopard-trail-blyde-canyon-point-de-vue-krystel-2.0bc47b2e.jpeg";